const keys = {
    ACCESS_TOKEN: "5ec75095-619a-4051-8a41-a0bebbf656d7",
    LICENCE_KEY: "b59f0803a328c5b2a9c91c5436c3f9fc"
};

export default keys;
